<template>
  <div class="home">
    <h2>Conditional License Tracking</h2>

    <v-snackbar
      top
      multi-line
      :color="snackbar.color"
      v-model="snackbar.visible"
    >
      {{this.snackbar.text}}
    </v-snackbar>

    <v-row dense class="mt-3">
      <v-col cols="12" md="3">
        <v-text-field
          rounded
          readonly
          class="text-black"
          label="Project Number"
          :value="prefix"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          rounded
          readonly
          class="text-black"
          label="Facility Name"
          :value="evaluation.providerName"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="3">
        <v-text-field
          rounded
          readonly
          class="text-black"
          label="Survey Type ID"
          :value="evaluation.surveyType"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          rounded
          readonly
          class="text-black"
          label="Survey Type"
          :value="evaluation.surveyTypeName"
        />
      </v-col>
    </v-row>

    <h3>Conditional Licenses</h3>

    <div v-if="licenses.length > 0">
      <v-row dense class="mt-3">
        <v-col cols="12" md="1">
          <p class="header">Visit</p>
        </v-col>
        <v-col cols="12" md="1">
          <p class="header">Duration</p>
        </v-col>
        <v-col cols="12" md="2">
          <p class="header">RN Consultant</p>
        </v-col>
        <v-col cols="12" md="2">
          <p class="header">No New Subst Maltx</p>
        </v-col>
        <v-col cols="12" md="2">
          <p class="header">No New Admissions</p>
        </v-col>
        <v-col cols="12" md="2">
          <p class="header">Other</p>
        </v-col>
      </v-row>

      <ConditionalLicense
        v-for="license in licenses"
        :key="license.id"
        :license="license"
        :pendingStatus="pendingLicenses.includes(license.id)"
        @togglePending="togglePending"
      />
    </div>

    <div v-if="licenses.length === 0">
      <h3 class="mt-3">No conditional licenses available for this evaluation</h3>
    </div>

    <v-row class="form-button">
      <v-col class="form-button">
        <v-btn @click="addLicense" color="primary">
          Add
        </v-btn>
      </v-col>
      <v-col class="form-button" >
        <v-btn @click="saveLicenses" color="primary">
          Save
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import ConditionalLicense from "./ConditionalLicense.vue";
  import {evalApi} from "@/plugins/axios";

  export default {
    props: {
      evaluation: Object
    },

    components: {ConditionalLicense},

    data() {
      return {
        licenses: [],
        snackbar: {
          visible: false,
          color: "#2a602c",
          text: ""
        },
        pendingLicenses: []
      }
    },

    created() {
      this.loadLicenses()
    },

    mounted() {
      window.scrollTo(0, 0)
    },

    computed: {
      prefix() {
        return this.evaluation.evaluationNumber.split('-')[0]
      },
      evalNums() {
        let evalNumList = []
        for (let license of this.licenses) {
          if (!evalNumList.includes(license.evaluationNumber)) {
            evalNumList.push(license.evaluationNumber)
          }
        }
        return evalNumList;
      }
    },

    methods: {
      loadLicenses() {
        evalApi.get(`conditionalLicense/getLicenses/` + this.prefix)
          .then(res => {
            this.licenses = res.data

            for (const license of this.licenses) {
              for (const key of Object.keys(license)) {
                if (key !== 'id' && key !== 'evaluationNumber' && key !== 'duration' && key !== 'comment') {
                  license[key] = this.formatDate(license[key])
                }
              }
            }
          })
          .catch(error => console.log(error.message))
      },

      addLicense() {
        this.licenses.push({
          id: crypto.randomUUID(),
          evaluationNumber: this.evaluation.evaluationNumber,
          duration: null,
          consultStartDt: null, consultEndDt: null,
          subStartDt: null, subEndDt: null,
          adminStartDt: null, adminEndDt: null,
          otherStartDt: null, otherEndDt: null,
          comment: null
        })
      },

      saveLicenses() {
        this.licenses = this.licenses.filter(license => !this.pendingLicenses.includes(license.id))
        evalApi.post(`/conditionalLicense/delete`, this.pendingLicenses).catch(() => {
          this.showErrorPopup("Something went wrong attempting to delete licenses.")
        })

        // Save remaining licenses
        evalApi.post(`/conditionalLicense/save`, this.licenses).then(res => {
          if (res.status === 204) {
            this.showErrorPopup("There are no licenses to save.")
          } else {
            this.showSuccessPopup("Licenses have been saved.")
          }
        }).catch(error => {
          if (error.response.status === 400) {
            this.showErrorPopup("Evaluation number does not exist for visit.")
          } else {
            this.showErrorPopup("Save failed due to an internal server error.")
          }
        })
      },

      formatDate(date) {
        return date != null ? new Date(date).toISOString().split('T')[0] : null
      },

      togglePending(id) {
        if (this.pendingLicenses.includes(id)) {
          this.pendingLicenses = this.pendingLicenses.filter(arrayId => arrayId !== id)
        } else this.pendingLicenses.push(id)
      },

      showErrorPopup(message) {
        this.snackbar.color = "#b60000";
        this.snackbar.text = message;
        this.snackbar.visible = true;
      },

      showSuccessPopup(message) {
        this.snackbar.color = "#2a602c";
        this.snackbar.text = message;
        this.snackbar.visible = true;
      }
    }
  }
</script>

<style>
  .text-black input {
    color: black !important;
  }

  .header {
    margin-bottom: 0 !important;
    font-size: 0.9em;
  }

  .form-button.row {
    justify-content: center;
    margin-top: 12px;
  }

  .form-button.col {
    flex-grow: 0 !important;
  }
</style>